import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { Mask, Toast } from 'antd-mobile';
import { confirmSimpleOrder, queryPayResult, getUserInfo } from '@/api/projectManager_self';
import { initManagementFees } from '@/api/guland';
import { hideLoading, showLoading } from '@/components/loading';
import styles from './managementTicketModal.module.scss';
import close from '@/assets/img/landfi/icon_del.png';

const ManagementTicketModal = ({
  onClose,
  landId,
  couponNum = 0,
  ticketCount = 0,
  payCallback,
}) => {
  const [visible, setVisible] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  const closeMask = () => {
    if (submitting) return;
    setVisible(false);
    onClose();
  };

  const onConfirm = async () => {
    if (!window.JsBridge?.hasWebViewBridge()) {
      Toast.show('请到APP中支付');
      return;
    }
    try {
      setSubmitting(true);
      showLoading();
      const { code: userCode, msg: userMsg, data: userData } = await getUserInfo();
      if (userCode !== '000000') throw userMsg;
      const { code: goodsCode, msg: goodsMsg, data: goodsData } = await initManagementFees({ landId });
      if (goodsCode !== '000000') throw goodsMsg;
      const reqInfo = { ...userData, ...goodsData };
      const params = {
        totalNum: 1,
        totalUsePoint: 0,
        totalUseCash: reqInfo.price || 0,
        payType: 'FEE_COUPON',
        source: 'app',
        uid: reqInfo.defRepeatStr,
        activityCode: 'LAND_MANAGEMENT_FEES',
        type: '6',
        productId: reqInfo.productId || '',
        landId: Array.isArray(reqInfo.landId) ? reqInfo.landId : [reqInfo.landId],
        couponNum,
      };
      const orderRes = await confirmSimpleOrder(params);
      if (orderRes.code !== '000000') throw orderRes.msg;
      hideLoading();
      showLoading();
      setTimeout(async () => {
        try {
          const { code, msg } = await queryPayResult({ outTradeNo: orderRes.data?.outTradeNo || '' });
          hideLoading();
          if (code !== '000000') throw msg;
          Toast.show({
            content: '支付成功',
            maskClickable: false,
            afterClose: () => {
              closeMask();
              payCallback && payCallback();
            },
          });
        } catch (error) {
          hideLoading();
          Toast.show(error);
        } finally {
          setSubmitting(false);
        }
      }, 1500);
    } catch (error) {
      hideLoading();
      setSubmitting(false);
      Toast.show(typeof error === 'string' ? error : error?.msg || '支付失败');
    }
  };

  return (
    <Mask className={styles.management_ticket_mask} visible={visible}>
      <div className={styles.management_ticket_container}>
        <div className={styles.header}>
          <span className={styles.close_btn} />
          <span className={styles.title}>A级土地管理</span>
          <img className={styles.close_btn} src={close} alt="" onClick={closeMask} />
        </div>
        <div className={styles.balance_box}>
          当前土地管理券：{ticketCount}
        </div>
        <div className={styles.confirm_tip}>
          确认消耗{couponNum}张土地管理券？
        </div>
        <div className={styles.btn_box}>
          <div className={`${styles.cancel_btn} ${styles.common_btn}`} onClick={closeMask}>取消</div>
          <div className={`${styles.confirm_btn} ${styles.common_btn}`} onClick={onConfirm}>确认</div>
        </div>
      </div>
    </Mask>
  );
};

ManagementTicketModal.open = ({ landId, couponNum, ticketCount, payCallback }) => {
  const div = document.createElement('div');
  document.body.appendChild(div);
  const close = () => {
    div.remove();
  };
  ReactDOM.render(
    <ManagementTicketModal
      onClose={close}
      landId={landId}
      couponNum={couponNum}
      ticketCount={ticketCount}
      payCallback={payCallback}
    />,
    div
  );
};

export default ManagementTicketModal;
